import React from "react";
import { VscVerifiedFilled } from "react-icons/vsc";

const TrustedLogos = ({ title, logos = [] }) => {
  return (
    <div className="mt-12 w-full overflow-hidden">
      {/* Title */}
      <div className="mb-8 flex items-center justify-center gap-2">
        <VscVerifiedFilled className="text-primary text-lg" />

        <p className="text-primary text-center text-lg font-medium">
          {title}
        </p>
      </div>

      {/* Logos Marquee */}
      <div className="relative overflow-hidden">
        {/* Left Fade */}
        <div className="from-light pointer-events-none absolute left-0 top-0 z-10 h-full w-20 bg-gradient-to-r to-transparent" />

        {/* Right Fade */}
        <div className="from-light pointer-events-none absolute right-0 top-0 z-10 h-full w-20 bg-gradient-to-l to-transparent" />

        <div className="flex w-max animate-marquee items-center gap-14 py-4">
          {[...logos, ...logos, ...logos].map((logo, index) => (
            <div
              key={index}
              className="flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-2xl border border-gray-100 bg-white/70 p-4 shadow-sm backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
            >
          <img
  src={logo}
  alt="client logo"
  className="max-h-full max-w-full object-contain transition duration-300"
/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedLogos;